import Navbar from "@/components/site/Navbar";
import { Seo } from "@/components/site/Seo";
import Hero from "@/components/site/Hero";
import ValuesStrip from "@/components/site/ValuesStrip";
import EthosBanner from "@/components/site/EthosBanner";
import Programs from "@/components/site/Programs";
import StandOut from "@/components/site/StandOut";
import Testimonials from "@/components/site/Testimonials";
import BlogTeaser from "@/components/site/BlogTeaser";
import FinalCTA from "@/components/site/FinalCTA";
import Footer from "@/components/site/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-[#F8FAFC] text-[#334155] font-body" data-testid="home-page">
      <Seo
        title="Happy Tiddlers | Baby & Children's Swimming Lessons | Barton-le-Clay"
        description="Fun, confidence-building swimming lessons for babies, children and adults in Barton-le-Clay, Bedfordshire. STA 'Swim Star' school since 2014. Book your lesson today."
        path="/"
      />
      <Navbar />
      <main>
        <Hero />
        <Programs />
        <ValuesStrip />
        <EthosBanner />
        <StandOut />
        <Testimonials />
        <BlogTeaser />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
